import { match } from "ts-pattern";

import { ReactComponent as Cancel } from "assets/images/Icons/cancel.svg";

import { EProjectFormat } from "common/enums/ProjectFormat/ProjectFormat";
import { EProjectTheme } from "common/enums/ProjectTheme/ProjectTheme";

import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";

import classes from "./classes.module.scss";

export enum ETagVariant {
	SORT = "sort",
	FORMAT = "format",
	THEME = "theme",
}

export enum EProjectSortOption {
	NEWEST = "newest",
	OLDEST = "oldest",
	MOST_LIKED = "most_liked",
	LEAST_LIKED = "least_liked",
}

type IProps = {
	value:
		| {
				label: EProjectTheme;
				variant: ETagVariant.THEME;
		  }
		| {
				label: EProjectFormat;
				variant: ETagVariant.FORMAT;
		  }
		| {
				label: EProjectSortOption;
				variant: ETagVariant.SORT;
		  };
	onClick?: () => void;
};

export default function Tag(props: IProps) {
	return (
		<div
			className={[
				classes["root"],
				match(props.value.variant)
					.with(ETagVariant.FORMAT, () => classes["format"])
					.with(ETagVariant.THEME, () => classes["theme"])
					.with(ETagVariant.SORT, () => classes["sort"])
					.exhaustive(),
			].join(" ")}>
			<Typography type="p" weight="medium" size="small" color="white" className={classes["label"]}>
				{match(props.value.variant)
					.with(ETagVariant.FORMAT, () => I18n.trslt(I18n.asset.pages.projects.tag.format[props.value.label as EProjectFormat]))
					.with(ETagVariant.THEME, () => I18n.trslt(I18n.asset.pages.projects.tag.theme[props.value.label as EProjectTheme]))
					.with(ETagVariant.SORT, () => I18n.trslt(I18n.asset.pages.projects.tag.sort[props.value.label as EProjectSortOption]))
					.exhaustive()}
			</Typography>
			<Cancel className={classes["cancel-icon"]} onClick={props.onClick} />
		</div>
	);
}
